import { withFields } from 'app-webtech-core/beacon/withFields';
import { ACTIVATE, FETCH_ALL, REMOVE } from '../actions/types';
import { pairingCodeInvalidBeacon } from './pairingCodeInvalid';
import { pairingErrorBeacon } from './pairingError';
import { pairingSuccessSecondaryBeacon } from './pairingSuccessSecondary';
import { pairingRemovedSecondaryBeacon } from './pairingRemovedSecondary';

export const pairedDevicesEventDefinitionsMap = {
  [ACTIVATE.FAILURE]: withFields(pairingCodeInvalidBeacon),
  [ACTIVATE.SUCCESS]: withFields(pairingSuccessSecondaryBeacon),
  [FETCH_ALL.FAILURE]: withFields(pairingErrorBeacon),
  [REMOVE.FAILURE]: withFields(pairingErrorBeacon),
  [REMOVE.SUCCESS]: withFields(pairingRemovedSecondaryBeacon),
};
